import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface TarifItem {
  freeReturnQuantityInKwhPerYear: number
  grossAmountPerMonthInEuro: number
  id: number
  netAmountPerMonthInEuro: number
  packageName: string
  prices: [
    {
      grossAmountPerMonthInEuro: number
      netAmountPerMonthInEuro: number
      validFrom: string
      validTo: string
    }
  ]
  productName: string
  tariffName: string
  validFrom: string
  validTo: string
}

export interface TarifState {
  tarifs: Array<TarifItem>
}

const initialState: TarifState = {
  tarifs: []
}

export const tarifSlice = createSlice({
  name: 'tarif',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setTarifSlice: (state, action: PayloadAction<Array<TarifItem>>) => {
      state.tarifs = action.payload
    }
  }
})

export const { setTarifSlice } = tarifSlice.actions

export default tarifSlice.reducer
